export * from './negocios.component';
export * from './filters-negocios-dialog.component';
export * from './precio-especial-dialog.component';
export * from './negocio-list/negocio-list.component';
export * from './negocio-list/neg-new-filters-dialog/neg-new-filters-dialog.component';



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/negocios/negocios/index.ts